import React, { useEffect, useState } from 'react';

import ScratchPopup from '../UI/ScratchPopup';

import CardForest from '../../Resources/images/card/Card-Forest.svg';
import CardGrass from '../../Resources/images/card/Card-Grass.svg';
import CardPurple from '../../Resources/images/card/Card-Purple.svg';
import CardPink from '../../Resources/images/card/Card-Pink.svg';

function CardList({ data, postApi, orderId, responseData }) {
	const [showScratchCard, setShowScratchCard] = useState(false);
	const [scratchData, setScratchData] = useState();
	const [scratchImage, setScratchImage] = useState();
	const [windowOffset, updateWindowOffset] = useState(0);

	useEffect(() => {
		if (showScratchCard) {
			updateWindowOffset(window.scrollY);
			document.body.setAttribute(
				'style',
				`position: fixed; top: -${window.scrollY}px; left: 0`
			);
		} else {
			document.body.setAttribute('style', '');
			window.scrollTo(0, windowOffset);
		}
	}, [showScratchCard]);

	const sendData = (value, image) => {
		setScratchData(value);
		setScratchImage(image);
		togglePopup();
	};

	const togglePopup = () => {
		setShowScratchCard(!showScratchCard);
	};
	return (
		<div className="CardList">
			<div className="CardList__Label">Scratch Cards</div>
			<div className="CardList__List">
				{data &&
					data.map((data, i) => {
						let scratchImageTemp = generateImage(i % 4);

						return (
							<div
								className="CardList__List--Item"
								onClick={() => sendData(data, scratchImageTemp)}
								key={i}
							>
								<img
									loading="lazy"
									src={data.scratchCard}
									alt="card"
									className="CardList__List--Item--Image"
								/>
							</div>
						);
					})}
			</div>
			{showScratchCard && scratchData && (
				<ScratchPopup
					data={scratchData}
					image={scratchImage}
					closeAction={togglePopup}
					orderId={orderId}
					postApi={postApi}
					responseData={responseData}
				/>
			)}
		</div>
	);
}

export default CardList;

const generateImage = (value) => {
	switch (value) {
		case 0:
			return CardForest;
		case 1:
			return CardGrass;
		case 2:
			return CardPink;
		case 3:
			return CardPurple;
		default:
			return CardForest;
	}
};
